import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '@/features/dashboard/components/dashboard-page'
import { siteConfig } from '@/site.config'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout/')({
  component: DashboardPage,
  beforeLoad: () => ({
    title: `${siteConfig.siteTitle} - Dashboard`,
    headerTitleKey: 'header.dashboard.title',
    headerDescriptionKey: 'header.dashboard.description',
  }),
})
